import { Injectable } from '@angular/core';
import { NzMessageService } from 'ng-zorro-antd/message';

@Injectable()
export class MessageService {
    constructor(private message: NzMessageService) { }

    success(msg = '保存成功') {
        this.message.create('success', msg);
    }

    error(msg = '处理失败') {
        this.message.create('error', msg);
    }
}